/* ARBACH Duftberater — Theme-Asset (Weg A). Als Theme-Asset hochladen: duftberater.js.
 * Kein Build, kein npm — diese Datei wird direkt vom Theme geladen.
 *
 * Erwartet im Seiten-Template (page.duftberater.liquid):
 *  - einen <script type="application/json" id="arb-cfg"> mit apiBase, turnstileSitekey,
 *    lang und den Texten,
 *  - die HTML-Struktur mit den IDs: arb-chat, arb-intro, arb-chips, arb-banner,
 *    arb-form, arb-in, arb-send, arb-count (Klassen/Styling frei änderbar).
 *
 * Ablauf: beim Laden GET {apiBase}/health (Kill-Switch/Shadow erkennen, ohne Session).
 * Session (Turnstile + Token) wird ERST bei der ersten Interaktion angelegt.
 * Produktkarten verlinken relativ (/products/…) — die Seite liegt in der Shop-Domain.
 *
 * VOLLBILD UND OVERLAY (Auftrag 20, Teil C, 05.10.2026): Die Seite läuft im Layout
 * layout/chat.liquid; im Shop holt das Overlay (snippets/duftberater-overlay.liquid)
 * denselben Chat beim ersten Öffnen aus einem <template> ins Dokument und lädt erst
 * dann diese Datei — #arb-app trägt dann data-modus="overlay". (Ein <iframe> geht
 * nicht: Shopify sendet X-Frame-Options: DENY.) Dafür hier: Links öffnen im
 * Hauptfenster (target=_top), das X führt direkt aufgerufen zurück in den Shop,
 * window.arbDuftberaterFokus() für das Overlay, Höhe bei offener Tastatur aus
 * visualViewport (nur als Seite), Prüffeld unter dem Gespräch statt darüber,
 * Vorschläge verschwinden nach der ersten Frage, Ereignis „arb:bereit" am Ende.
 */
(function () {
  "use strict";

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById("arb-cfg").textContent); } catch (e) { CFG = {}; }
  var API = (CFG.apiBase || "").replace(/\/$/, "");
  var SUPPORTED = { de: 1, en: 1, ro: 1, sr: 1, ar: 1 }; // fuenf gefuehrte Sprachen
  var LANG = SUPPORTED[CFG.lang] ? CFG.lang : "de";
  var TX = CFG.texte || {};
  var MAXLEN = CFG.maxLen || 500;

  // Text aus dem Config-Block (mandantenspezifisch), Sprache mit Fallback DE.
  function tx(key) { var o = TX[key] || {}; return o[LANG] || o.de || ""; }

  // Generische UI-Beschriftungen (nicht mandantenspezifisch).
  var UI = {
    de: { zumDuft: "Zum Duft", nichtVerf: "derzeit nicht verfügbar", tippen: "schreibt…",
          team: "Zum Kontakt", fotoFolgt: "Foto folgt",
          turnstile: "Der Duftberater konnte nicht gestartet werden — vermutlich blockiert ein Ad- oder Consent-Blocker die Sicherheitsprüfung. Bitte lade die Seite neu oder melde dich direkt bei uns:",
          fehler: "Da ist gerade etwas schiefgelaufen. Versuch es bitte noch einmal.",
          inaktiv: "Der Duftberater ist im Moment nicht verfügbar. Melde dich gern direkt bei unserem Team:",
          zuschnell: "Kurz durchatmen — das waren gerade viele Anfragen. Versuch es in einer Minute noch einmal.",
          pruefe: "Sicherheitsprüfung läuft…",
          origin: "Diese Seite ist beim Duftberater noch nicht freigeschaltet. Bitte melde dich bei uns:",
          turnstileWert: "Die Sicherheitsprüfung wurde abgelehnt. Meist stimmt der hinterlegte Turnstile-Wert nicht oder diese Seite ist noch nicht freigeschaltet. Bitte melde dich bei uns:" },
    en: { zumDuft: "View fragrance", nichtVerf: "currently unavailable", tippen: "typing…",
          team: "Contact us", fotoFolgt: "Photo soon",
          turnstile: "The advisor couldn't start — an ad or consent blocker is likely blocking the security check. Please reload the page or contact us directly:",
          fehler: "Something went wrong just now. Please try again.",
          inaktiv: "The advisor is currently unavailable. Please reach out to our team directly:",
          zuschnell: "Take a short break — that was a lot of requests. Please try again in a minute.",
          pruefe: "Security check running…",
          origin: "This domain is not yet enabled for the advisor. Please contact us:",
          turnstileWert: "The security check was rejected. Usually the configured Turnstile value is wrong or this site is not enabled yet. Please contact us:" },
    ro: { zumDuft: "Vezi parfumul", nichtVerf: "momentan indisponibil", tippen: "scrie…",
          team: "Contact", fotoFolgt: "Foto în curând",
          turnstile: "Consilierul de parfumuri nu a putut porni — probabil un blocant de reclame sau de consimțământ blochează verificarea de securitate. Reîncarcă pagina sau contactează-ne direct:",
          fehler: "Ceva n-a mers acum. Te rog încearcă din nou.",
          inaktiv: "Consilierul de parfumuri nu este disponibil momentan. Contactează direct echipa noastră:",
          zuschnell: "Ia o pauză scurtă — au fost multe cereri. Încearcă din nou peste un minut.",
          pruefe: "Verificare de securitate în curs…",
          origin: "Acest domeniu nu este încă activat pentru consilier. Te rugăm să ne contactezi:",
          turnstileWert: "Verificarea de securitate a fost respinsă. De obicei valoarea Turnstile configurată nu este corectă sau acest site nu este încă activat. Te rugăm să ne contactezi:" },
    sr: { zumDuft: "Pogledaj miris", nichtVerf: "trenutno nedostupno", tippen: "kuca…",
          team: "Kontakt", fotoFolgt: "Foto uskoro",
          turnstile: "Savetnik za mirise nije mogao da se pokrene — verovatno bloker reklama ili kolačića blokira bezbednosnu proveru. Osveži stranicu ili nas kontaktiraj direktno:",
          fehler: "Nešto je pošlo naopako. Pokušaj ponovo.",
          inaktiv: "Savetnik za mirise trenutno nije dostupan. Javi se direktno našem timu:",
          zuschnell: "Predahni na trenutak — bilo je mnogo upita. Pokušaj ponovo za minut.",
          pruefe: "Bezbednosna provera u toku…",
          origin: "Ovaj domen još nije odobren za savetnika. Javi nam se:",
          turnstileWert: "Bezbednosna provera je odbijena. Najčešće podešeni Turnstile ključ nije tačan ili ovaj sajt još nije odobren. Javi nam se:" },
    ar: { zumDuft: "عرض العطر", nichtVerf: "غير متوفّر حالياً", tippen: "يكتب…",
          team: "تواصل معنا", fotoFolgt: "الصورة قريباً",
          turnstile: "تعذّر بدء مستشار العطور — على الأرجح يمنع مانع إعلانات أو مانع موافقة فحص الأمان. يُرجى إعادة تحميل الصفحة أو التواصل معنا مباشرة:",
          fehler: "حدث خطأ ما للتو. يُرجى المحاولة مرة أخرى.",
          inaktiv: "مستشار العطور غير متاح حالياً. تواصل مباشرة مع فريقنا:",
          zuschnell: "خذ استراحة قصيرة — كانت هناك طلبات كثيرة. حاول مرة أخرى بعد دقيقة.",
          pruefe: "جارٍ فحص الأمان…",
          origin: "هذا النطاق غير مُفعَّل بعد لدى المستشار. يُرجى التواصل معنا:",
          turnstileWert: "تم رفض فحص الأمان. غالباً ما تكون قيمة Turnstile المُعدّة غير صحيحة أو أن هذا الموقع غير مُفعَّل بعد. يُرجى التواصل معنا:" }
  };
  // Sprachbezug: `ui()`/`tx()` folgen der SEITENsprache (Beschriftungen, die
  // schon vor der ersten Antwort dastehen). `uiL()`/`txL()` folgen der Sprache
  // EINER ANTWORT — Kartenbeschriftung, Pflichtzeile und KI-Hinweis gehören
  // dorthin, sonst steht unter einer arabischen Antwort eine deutsche
  // Pflichtzeile, sobald der Shop nur Deutsch veröffentlicht hat.
  function uiL(lang) { return UI[lang] || UI[LANG] || UI.de; }
  function txL(key, lang) { var o = TX[key] || {}; return o[lang] || o[LANG] || o.de || ""; }
  function ui() { return uiL(LANG); }
  function kontaktUrl() { return CFG.kontaktUrl || "#"; }

  // Sind die beiden Template-Werte (apiBase, turnstileSitekey) noch nicht ausgefüllt?
  // Ein nicht ersetzter Platzhalter beginnt mit "<" (z. B. "<API-BASIS>"). Dann NICHT
  // den allgemeinen Fehlerzustand zeigen, sondern klar sagen, was fehlt — sonst
  // scheitert der Chat erst beim ersten Absenden mit einer irreführenden Meldung.
  var CFG_MSG = {
    de: { api: "Konfiguration unvollständig — apiBase im Seiten-Template nicht eingesetzt.",
          site: "Konfiguration unvollständig — Turnstile-Sitekey im Seiten-Template nicht eingesetzt." },
    en: { api: "Configuration incomplete — apiBase is not set in the page template.",
          site: "Configuration incomplete — the Turnstile sitekey is not set in the page template." },
    ro: { api: "Configurație incompletă — apiBase nu este setat în șablonul paginii.",
          site: "Configurație incompletă — cheia Turnstile (sitekey) nu este setată în șablonul paginii." },
    sr: { api: "Konfiguracija nepotpuna — apiBase nije postavljen u šablonu stranice.",
          site: "Konfiguracija nepotpuna — Turnstile sitekey nije postavljen u šablonu stranice." },
    ar: { api: "الإعداد غير مكتمل — لم يتم ضبط apiBase في قالب الصفحة.",
          site: "الإعداد غير مكتمل — لم يتم ضبط مفتاح Turnstile في قالب الصفحة." }
  };
  function istLokal() {
    var h = location.hostname;
    return h === "localhost" || h === "127.0.0.1" || h === "";
  }

  function configUnvollstaendig() {
    var m = CFG_MSG[LANG] || CFG_MSG.de;
    if (!API || API.charAt(0) === "<") return m.api;
    if ((CFG.turnstileSitekey || "").charAt(0) === "<") return m.site;
    // LEERER Sitekey ist in Produktion dasselbe Problem wie ein Platzhalter:
    // die Seite schickt "dev-local", der Worker lehnt mit 403 ab, und der Kunde
    // liest "vermutlich ein Adblocker" — für einen Fehler, den ein leergeräumtes
    // Feld verursacht hat. Auf localhost bleibt der Dev-Pfad erlaubt, dort ist
    // er gemeint.
    if (!CFG.turnstileSitekey && !istLokal()) return m.site;
    return "";
  }

  var els = {};
  var state = { token: null, sending: false, booting: null, ended: false };
  // Im Overlay des Shops? (data-modus am #arb-app, gesetzt von snippets/duftberater-chat.liquid)
  var APP = document.getElementById("arb-app");
  var IM_OVERLAY = !!APP && APP.getAttribute("data-modus") === "overlay";

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function scroll() { els.chat.scrollTop = els.chat.scrollHeight; }
  // Seit Auftrag 20: die Begrüßung bleibt als erste Blase stehen, nur die
  // Vorschläge über der Eingabe verschwinden nach der ersten Frage.
  function hideIntro() { if (els.chips) els.chips.hidden = true; }

  function addMsg(role, text, lang) {
    var m = el("div", "arb-msg " + (role === "user" ? "arb-u" : "arb-a"), text);
    // Die SEITE trägt die Richtung der Shop-Sprache. Der Bot antwortet aber in
    // der Sprache des KUNDEN — schreibt jemand im deutschen Storefront arabisch,
    // käme die arabische Antwort sonst in einem linksläufigen Absatz. Deshalb
    // hier je Nachricht, aus dem Feld `lang` der Antwort (SCHNITTSTELLE.md).
    if (lang) m.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    els.chat.insertBefore(m, els.banner);
    scroll();
    return m;
  }
  // Kurzer KI-Hinweis unter einer Antwort (AI Act A1). Nur wenn im Config-Text gesetzt.
  function addAnswerHint(lang) {
    var t = txL("kiHinweis", lang);
    if (!t) return;
    var h = el("div", "arb-hint", t);
    // Auch der Pflichthinweis braucht die Richtung der ANTWORT — sonst sitzen
    // Gedankenstrich und Schlusspunkt eines arabischen Hinweises auf der
    // falschen Seite, während Antwort und Karte darüber korrekt gespiegelt sind.
    if (lang) h.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    els.chat.insertBefore(h, els.banner);
    scroll();
  }

  // JE GRÖSSE ein eigenes Element, damit eine ausverkaufte Größe wirklich
  // AUSGEGRAUT werden kann (Klasse .arb-so). Vorher war die Preiszeile ein
  // einziger Textknoten und .arb-so wurde nur gesetzt, wenn BEIDE Größen weg
  // waren — die Zusage „ausgegraut, nicht ausgeblendet" war für den häufigen
  // Fall (eine von zwei Größen) nicht umgesetzt und auch nicht umsetzbar.
  function preisZeile(groessen, lang) {
    var zeile = el("div", "arb-pr");
    (groessen || []).forEach(function (g, i) {
      if (i) zeile.appendChild(document.createTextNode("  ·  "));
      var t = g.verfuegbar ? (g.ml + " ml " + g.preis) : (g.ml + " ml — " + uiL(lang).nichtVerf);
      zeile.appendChild(el("span", g.verfuegbar ? null : "arb-so", t));
    });
    return zeile;
  }
  // Grundpreis JE GRÖSSE, mit derselben Ausgrauung wie der Preis darüber.
  // Sonst steht unter einem ausgegrauten „50 ml — nicht verfügbar" ein
  // Grundpreis in voller Kontraststärke, und die Zuordnung Preis↔Grundpreis
  // wird für den Kunden mehrdeutig — ausgerechnet bei einer Pflichtangabe.
  function gpZeile(groessen) {
    var zeile = el("div", "arb-gp");
    (groessen || []).forEach(function (g, i) {
      if (i) zeile.appendChild(document.createTextNode("  ·  "));
      zeile.appendChild(el("span", g.verfuegbar ? null : "arb-so", g.grundpreis));
    });
    return zeile;
  }
  function placeholderIm(box, lang) { box.textContent = uiL(lang).fotoFolgt; }

  //  ist die Sprache der ANTWORT (SCHNITTSTELLE.md), nicht die der Seite.
  function addCards(cards, lang) {
    (cards || []).forEach(function (c) {
      var card = el("div", "arb-card" + (c.alleAusverkauft ? " arb-out" : ""));
      if (lang) card.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
      var im = el("div", "arb-im");
      if (c.image) {
        var img = document.createElement("img");
        img.src = c.image; img.alt = c.name; img.loading = "lazy";
        img.onerror = function () { im.innerHTML = ""; placeholderIm(im, lang); };
        im.appendChild(img);
      } else { placeholderIm(im, lang); }
      card.appendChild(im);
      var bd = el("div", "arb-bd");
      bd.appendChild(el("h3", null, c.name));
      bd.appendChild(el("div", "arb-fam", c.family + " · " + c.charakter));
      bd.appendChild(preisZeile(c.groessen, lang));
      bd.appendChild(gpZeile(c.groessen));
      var pf = txL("pflichtzeile", lang); // PrAG/UWG: Preisbezug + Verweis auf den Shop.
      // KEINE Frist hier — siehe Kasten in ANLEITUNG.md, Phase 0b.
      if (pf) bd.appendChild(el("div", "arb-pflicht", pf));
      var a = el("a", "arb-zum", uiL(lang).zumDuft);
      // Relativ, gleicher Tab — bewusst KEIN target="_blank" (SCHNITTSTELLE.md).
      // WURZEL VORANSTELLEN: Shopify liefert Zweitsprachen unter /en/, /ar/ …;
      // ein wurzelrelativer Link würde den Kunden aus seiner Sprache heraus auf
      // die deutsche Produktseite werfen. `shopWurzel` kommt aus dem Template
      // (routes.root_url) und ist im Standardfall "/".
      a.href = mitWurzel(c.url);
      // Im Overlay öffnet „Zum Duft" im HAUPTFENSTER (Auftrag 20, C1) — die Seite
      // wechselt, das Overlay ist damit zu. Direkt aufgerufen ist _top dasselbe Fenster.
      a.target = "_top";
      bd.appendChild(a);
      card.appendChild(bd);
      els.chat.insertBefore(card, els.banner);
    });
    scroll();
  }

  function banner(html) { els.banner.innerHTML = ""; var b = el("div", "arb-banner"); b.innerHTML = html; els.banner.appendChild(b); scroll(); }
  function clearBanner() { els.banner.innerHTML = ""; }
  function kontaktLink(label) { return '<a href="' + kontaktUrl() + '" target="_top">' + label + "</a>"; }

  /** Shopify-Sprachwurzel vor einen wurzelrelativen Pfad setzen ("/" → unverändert). */
  function mitWurzel(pfad) {
    var w = (CFG.shopWurzel || "/").replace(/\/+$/, "");
    if (!w || pfad.charAt(0) !== "/") return pfad;
    return w + pfad;
  }

  // Ersatztext AUS DIESEM TEMPLATE (nicht vom Worker) — plus den Weg zum Team.
  //
  // Warum das zusammengehört: Der Worker hängt seit dem Korridor-Umbau an jeden
  // Verweistext die Kontaktwege an. Diese hier sind die Fassungen für den Fall,
  // dass der Worker gar nicht antwortet — und genau dann braucht der Kunde den
  // Kontakt am dringendsten, bekam ihn aber als Einziges nicht. „Melde dich beim
  // Team" ohne zu sagen wie, ist der Fehler, den der Umbau beseitigen sollte.
  //
  // Der Link kommt über banner(), nicht in die Nachricht: addMsg() setzt
  // textContent (Antworttext wird nie als HTML eingesetzt — das bleibt so).
  function ersatzMsg(key) {
    addMsg("assistant", tx(key) || ui().fehler);
    banner(kontaktLink(ui().team));
  }

  function typing(on) {
    if (on) { if (!els.typing) { els.typing = el("div", "arb-typing", ui().tippen); els.chat.insertBefore(els.typing, els.banner); scroll(); } }
    else if (els.typing) { els.typing.remove(); els.typing = null; }
  }

  function renderChips() {
    var list = (TX.chips && TX.chips[LANG]) || [];
    if (!els.chips || !list.length) return;
    list.forEach(function (label) {
      var chip = el("button", "arb-chip", label); chip.type = "button";
      chip.addEventListener("click", function () { send(label); });
      els.chips.appendChild(chip);
    });
  }

  // --- Turnstile (Site-Key aus dem Config-Block) --------------------------
  // Leerer Sitekey → Token "dev-local": NUR für lokale Tests gegen ein Worker-
  // Test-Secret gedacht. In Produktion lehnt der Worker (echtes Secret) "dev-local"
  // mit 403 ab — kein echter Bypass. Ein noch nicht ausgefüllter Platzhalter ("<…>")
  // wird bereits von configUnvollstaendig() abgefangen und erreicht diesen Pfad nicht.
  function turnstileToken() {
    if (!CFG.turnstileSitekey) return Promise.resolve("dev-local");
    return new Promise(function (resolve) {
      var done = false;
      // Nach 2,5 s ein Lebenszeichen. Ohne das steht die Seite bei blockiertem
      // Turnstile bis zu 20 Sekunden still — kein Spinner, kein Text, Senden
      // deaktiviert. Wer testet, hält die Seite für eingefroren und sucht den
      // Fehler in Template und Assets statt im Blocker.
      var hinweis = setTimeout(function () { if (!done) banner(ui().pruefe); }, 2500);
      function finish(v) {
        if (done) return;
        done = true; clearTimeout(hinweis); clearBanner(); resolve(v);
      }
      // Der Widget-Kasten gehört in DIESEN Bereich, nicht in run(): Der Timeout
      // unten muss ihn aufräumen können, und er wird VOR run() angelegt.
      // Stand er in run(), warf der Timeout `ReferenceError: box is not
      // defined` — und zwar BEVOR finish() lief. Die Zusage löste dann nie
      // auf, der Senden-Knopf blieb für immer grau, und ausgerechnet der
      // Pfad „Turnstile hängt" hatte keinen Ausgang mehr. Gefunden im
      // siebten Fremdleser-Durchgang, eingebaut im sechsten.
      var box = null;
      function raeumAuf() { if (box && box.parentNode) box.parentNode.removeChild(box); box = null; }
      var timer = setTimeout(function () { raeumAuf(); finish(""); }, 20000);
      function run() {
        try {
          // EIGENER Container, NICHT els.banner. `banner()` leert sein Element
          // per innerHTML — stünde das Widget darin, würde der
          // „Sicherheitsprüfung läuft"-Hinweis nach 2,5 s das Widget aus dem DOM
          // reißen. Die Prüfung könnte dann nie fertig werden, nach 20 s liefe
          // sie in den Timeout, und die Seite behauptete „vermutlich ein
          // Adblocker". Bei schnellem Netz fällt das nie auf.
          box = el("div", "arb-pruefung");
          // OBEN IM CHAT, NICHT UNTEN (Auftrag 12, Teil 9.1, 01.10.2026): vor dem
          // Umbau stand der Kasten direkt vor els.banner, also am unteren Rand des
          // Chats — und damit hinter Shopifys fixem Cookie-Banner, solange der
          // Kunde es nicht beantwortet hat (gemessen: Widget 488–559 px, Banner ab
          // 482 px, volle Ueberdeckung). Verlangt Turnstile im Managed-Modus einen
          // Klick, sieht ihn niemand, nach 20 s laeuft die Pruefung in den Timeout
          // und die Seite behauptet „vermutlich ein Adblocker". Jetzt steht der
          // Kasten als erstes Kind des Chats und wird in die Bildschirmmitte
          // gescrollt — sichtbar, egal ob das Banner offen ist. Dieselbe Loesung
          // fuer Handys, wo das Banner das untere Drittel deckt.
          // SEIT AUFTRAG 20 (N28): unter Begrüßung und Gespräch, direkt über
          // der Eingabe, in voller Breite (size: flexible). Im Vollbild liegt
          // dort nichts mehr darüber: die Cookie-Leiste ist im Overlay-Rahmen
          // ausgeblendet, und die Eingabe sitzt unter dem Gesprächsbereich.
          els.chat.insertBefore(box, els.banner);
          try { box.scrollIntoView({ block: "nearest" }); } catch (e) { /* alte Browser */ }
          window.turnstile.render(box, {
            sitekey: CFG.turnstileSitekey,
            size: "flexible",
            callback: function (tok) { clearTimeout(timer); raeumAuf(); finish(tok); },
            "error-callback": function () { clearTimeout(timer); raeumAuf(); finish(""); },
            "expired-callback": function () { raeumAuf(); finish(""); }
          });
        } catch (e) { clearTimeout(timer); raeumAuf(); finish(""); }
      }
      if (window.turnstile) return run();
      var s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js"; s.async = true;
      s.onload = run; s.onerror = function () { clearTimeout(timer); finish(""); };
      document.head.appendChild(s);
    });
  }

  function boot() {
    if (state.token) return Promise.resolve(true);
    if (state.booting) return state.booting;
    state.booting = (async function () {
      try {
        var tok = await turnstileToken();
        if (!tok) throw new Error("turnstile");
        var res = await fetch(API + "/session", {
          method: "POST", headers: { "content-type": "application/json" },
          body: JSON.stringify({ turnstileToken: tok, lang: LANG })
        });
        var d = await res.json();
        if (d && d.inactive) { endSession(ui().inaktiv + " " + kontaktLink(ui().team)); return false; }
        // Fehler UNTERSCHEIDEN. Vorher lief jeder Fehlschlag in denselben
        // Adblocker-Text — auch das Ratelimit und die nicht freigeschaltete
        // Domain. Wer testet, sucht dann im Consent-Tool nach einem Fehler,
        // der im Netzwerk-Tab klar dasteht.
        if (res.status === 429) { banner(ui().zuschnell); return false; }
        if (res.status === 403 && d && d.error === "origin_not_allowed") {
          banner(ui().origin + " " + kontaktLink(ui().team)); return false;
        }
        // turnstile_failed BEIM NAMEN nennen. Sonst landet ausgerechnet der
        // Fall „eigener Sitekey / Domain nicht eingetragen" im Adblocker-Text —
        // und man sucht im Consent-Tool, während der Netzwerk-Tab es klar sagt.
        if (res.status === 403 && d && d.error === "turnstile_failed") {
          banner(ui().turnstileWert + " " + kontaktLink(ui().team)); return false;
        }
        if (!res.ok || !d.token) throw new Error("session");
        state.token = d.token;
        if (SUPPORTED[d.sprache]) LANG = d.sprache;
        return true;
      } catch (e) {
        banner(ui().turnstile + " " + kontaktLink(ui().team));
        return false;
      } finally { state.booting = null; }
    })();
    return state.booting;
  }

  function post(message) {
    return fetch(API + "/chat", {
      method: "POST", headers: { "content-type": "application/json" },
      body: JSON.stringify({ token: state.token, message: message })
    });
  }

  // /chat einmal ausführen und die Antwort als JSON lesen (oder d=null, wenn kein JSON).
  function chatOnce(message) {
    return post(message).then(function (res) {
      return res.json().then(
        function (d) { return { res: res, d: d }; },
        function () { return { res: res, d: null }; }
      );
    });
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function endSession(text) {
    state.ended = true;
    els.in.disabled = true; els.send.disabled = true; els.in.placeholder = "—";
    if (text) banner(text);
  }

  async function send(text) {
    text = (text != null ? text : els.in.value).trim();
    if (!text || state.sending || state.ended) return;
    // Nicht ausgefüllte Template-Platzhalter klar melden (statt kryptisch scheitern).
    var cfgFehlt = configUnvollstaendig();
    if (cfgFehlt) { hideIntro(); addMsg("user", text); els.in.value = ""; autosize(); updateCount(); banner(cfgFehlt); return; }
    state.sending = true; els.send.disabled = true; // Guard VOR boot-Await (kein Doppel-Senden)
    if (!state.token) { var ok = await boot(); if (!ok) { state.sending = false; if (!state.ended) els.send.disabled = false; return; } }
    hideIntro(); clearBanner();
    var eigene = addMsg("user", text);
    els.in.value = ""; autosize(); updateCount();
    typing(true);
    try {
      var r = await chatOnce(text);
      // Die eigene Nachricht des Kunden nachträglich in die Richtung der Antwort
      // drehen: Beim Absenden weiß die Seite die Sprache noch nicht, danach
      // schon. Sonst steht eine arabische Frage linksläufig über einer korrekt
      // rechtsläufigen Antwort, und das sieht nach einem Einbaufehler aus.
      if (r.d && r.d.lang && eigene) eigene.setAttribute("dir", r.d.lang === "ar" ? "rtl" : "ltr");
      // Token abgelaufen → einmal neu anmelden und erneut senden.
      if (r.res.status === 401) {
        state.token = null;
        var ok2 = await boot();
        if (!ok2) { typing(false); state.sending = false; return; }
        r = await chatOnce(text);
      }
      // 1042/Kaltstart: EIN stiller Retry bei 5xx ODER nicht-JSON — NICHT bei 429/4xx.
      if ((r.res.status >= 500 || r.d === null) && r.res.status !== 429 && !(r.res.status >= 400 && r.res.status < 500)) {
        await wait(800);
        r = await chatOnce(text);
      }
      var res = r.res, d = r.d || {};
      typing(false);
      // 429 hat einen EIGENEN Hinweis. Ohne ihn landete das Ratelimit im
      // Ersatztext „komme gerade nicht weiter" — der Kunde denkt, der Bot ist
      // kaputt, und wer testet, sucht den Fehler in CSP und Consent-Tool.
      if (res.status === 429) { banner(ui().zuschnell); return; }
      if (d.inactive) { endSession(ui().inaktiv + " " + kontaktLink(ui().team)); return; }
      if (d.shadow) {
        if (d.reply) addMsg("assistant", d.reply, d.lang);
        else ersatzMsg("shadow");
      } else if (d.reply) {
        addMsg("assistant", d.reply, d.lang);
        addAnswerHint(d.lang);
        addCards(d.cards, d.lang);
      } else {
        // Antwort ohne `reply` — ob mit 200 oder mit Fehlerstatus, für den Kunden
        // ist es dasselbe: hier steht nichts, was ihm hilft. Also Ersatztext samt
        // Kontaktweg. (Kein KI-Hinweis darunter: der Text kommt nicht von der KI.)
        ersatzMsg("fallback");
      }
      // Sitzungsende MIT Text. Vorher sperrte das Eingabefeld kommentarlos und
      // der Platzhalter wurde zu „—" — der Kunde stand vor einer toten Seite und
      // wusste nicht, warum. Der Text steht im Config-Block (texte.limit) und
      // wurde bis dahin von niemandem gelesen.
      // Schlusstext NICHT doppelt: Bei `limit` liefert der Worker ihn bereits
      // als `reply` und die Blase steht schon da. Der Config-Text ist nur der
      // Rückfall, wenn keine Antwort kam — sonst stünde derselbe Satz zweimal,
      // bei einem arabischen Gespräch einmal arabisch und einmal deutsch.
      // ZWEI VERSCHIEDENE FAELLE, und sie waren zusammengefasst:
      //  · `limit:true` — der Worker hat den Schlusstext SELBST geschickt, er
      //    steht schon als Blase da. Ein zweiter waere derselbe Satz doppelt,
      //    bei einem arabischen Gespraech einmal arabisch und einmal deutsch.
      //  · `turnsLeft === 0` — die 12. Antwort ist gerade gekommen und ist eine
      //    NORMALE Antwort. Ohne eigenen Text sperrt das Feld kommentarlos, und
      //    die `limit`-Antwort mit dem Schlusstext kommt nie, weil niemand mehr
      //    senden kann. Genau der Abnahmepunkt, der dadurch unerfuellbar war.
      if (d.limit) endSession("");
      else if (d.turnsLeft === 0) endSession(txL("limit", d.lang));
    } catch (e) {
      typing(false);
      ersatzMsg("fallback");
    } finally {
      state.sending = false;
      if (!state.ended) els.send.disabled = false;
    }
  }

  function autosize() { els.in.style.height = "auto"; els.in.style.height = Math.min(els.in.scrollHeight, 120) + "px"; }
  function updateCount() {
    var len = els.in.value.length;
    els.count.textContent = len >= MAXLEN - 100 ? (len + "/" + MAXLEN) : "";
  }

  // Kill-Switch/Shadow ohne Session erkennen (tokenloses /health).
  async function checkHealth() {
    // Bei unvollständiger Konfiguration NICHT anfragen: API wäre der Platzhalter
    // und die URL damit relativ zur Shop-Domain — ein 404 in der Konsole, der wie
    // ein CSP-Problem aussieht und den Abnahmepunkt „Konsole fehlerfrei" reißt.
    if (configUnvollstaendig()) return;
    try {
      var r = await fetch(API + "/health");
      var h = await r.json();
      if (h && h.aktiv === false) { endSession(ui().inaktiv + " " + kontaktLink(ui().team)); return; }
      // shadow SOFORT zeigen, nicht erst nach der ersten Nachricht. Sonst sieht
      // die Seite beim Laden normal aus und der Testbetrieb wirkt behoben.
      if (h && h.shadow === true) banner(tx("shadow") || "");
    } catch (e) { /* Health nicht erreichbar → normal weiter, /session fängt es ab */ }
  }

  function init() {
    els.chat = document.getElementById("arb-chat");
    els.intro = document.getElementById("arb-intro");
    els.chips = document.getElementById("arb-chips");
    els.banner = document.getElementById("arb-banner");
    els.form = document.getElementById("arb-form");
    els.in = document.getElementById("arb-in");
    els.send = document.getElementById("arb-send");
    els.count = document.getElementById("arb-count");
    if (!els.chat || !els.form) return;

    // Begrüßung aus dem Config-Block (falls das Template sie nicht schon statisch zeigt).
    if (els.intro && !els.intro.dataset.filled) {
      var greet = tx("begruessung");
      if (greet) { var p = el("p", null, greet); els.intro.insertBefore(p, els.chips); }
    }
    renderChips();

    els.form.addEventListener("submit", function (e) { e.preventDefault(); send(); });
    els.in.addEventListener("input", function () { autosize(); updateCount(); });
    els.in.addEventListener("keydown", function (e) { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } });
    els.in.setAttribute("maxlength", String(MAXLEN));

    checkHealth();       // Kill-Switch sofort erkennen
    // Fokus NUR auf großen Fenstern. Auf dem Handy öffnete das sofort die
    // Tastatur über dem KI-Hinweis. Im Overlay bestimmt die Seite den Fokus
    // (Nachricht „fokus" unten): Handy der Kopf, Rechner das Eingabefeld.
    if (!IM_OVERLAY && window.innerWidth >= 900 && els.in.focus) els.in.focus();
    vollbild();
  }

  // ---------------------------------------------------------------- Vollbild
  function vollbild() {
    els.kopf = document.getElementById("arb-kopf");
    var zu = document.getElementById("arb-zu");
    // X als Seite: zurück, wenn die vorige Seite vom Shop kommt, sonst „Alle Düfte"
    // mit Sprachpräfix (data-zurueck). Im Overlay ist dieses X ausgeblendet — dort
    // schließt das X des Overlays an derselben Stelle.
    if (zu) zu.addEventListener("click", function () {
      if (IM_OVERLAY) { if (typeof window.arbDuftberaterSchliessen === "function") window.arbDuftberaterSchliessen(); return; }
      var vomShop = false;
      try { vomShop = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) { vomShop = false; }
      if (vomShop && window.history.length > 1) window.history.back();
      else window.location.href = (APP && APP.getAttribute("data-zurueck")) || "/";
    });
    // Fokus auf Wunsch des Overlays: Handy der Kopf, Rechner das Eingabefeld
    window.arbDuftberaterFokus = function (ziel) {
      var e = ziel === "eingabe" ? els.in : els.kopf;
      if (e) { try { e.focus({ preventScroll: true }); } catch (x) { e.focus(); } }
    };
    // Tastatur offen (nur als Seite): Höhe des sichtbaren Bereichs, damit die
    // Eingabe sichtbar bleibt — 100dvh schrumpft mit der Tastatur nicht. Im
    // Overlay folgt das Overlay selbst dem sichtbaren Bereich.
    var vv = window.visualViewport;
    if (vv && !IM_OVERLAY) {
      var setze = function () {
        document.documentElement.style.setProperty("--arb-hoehe", Math.round(vv.height) + "px");
        if (window.scrollY) window.scrollTo(0, 0);
      };
      vv.addEventListener("resize", setze);
      setze();
    }
    try { document.dispatchEvent(new CustomEvent("arb:bereit")); } catch (e) { /* sehr alte Browser */ }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
